import apiRoutes from './api.routes';
import ModelService from './model.service';

const RoleService = new ModelService(apiRoutes.roles, '/users/roles', 'roles');


export default RoleService;



// WEBPACK FOOTER //
// ./src/services/role.service.js